import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useCanonical = () => {
  const location = useLocation();

  useEffect(() => {
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', `https://creditautoreset.ca${location.pathname}`);
  }, [location.pathname]);
};

export default useCanonical;
